//FacilityForm.vue
<template>
  <div class="form-tab">
    <div v-if="isLoading.form" class="text-center">
      <ProgressSpinner />
    </div>
    <TabView v-else :activeIndex="tabIndex" @tab-change="onTabChange($event.index)">
      <TabPanel v-for="(item, i) in form" :key="item.form_id"
        :disabled="($route.params.facility_id == 0 && item.form_class === 'TTMPropertyLogForm')">
        <template #header>
          <img :src="require(`/public/images/24x24/${item.form_image_index}.png`)" width="20"
            v-tooltip="info.isAdmin ? item.form_class : ''" />
          <span class="ml-1 form-tab-text" v-tooltip="info.isAdmin ? item.form_class : ''">{{ item.form_name }} {{
            i === 0 ? getFacilityNameBracket() : "" }}
          </span>
        </template>
        <div v-if="isLoading.formScript" class="text-center">
          <ProgressSpinner />
        </div>
        <component :is="formComponents[item.form_class]" v-if="i === tabIndex && !isLoading.formScript"
          :scriptId="formScript?.script_id" :interception="tabIndex === 0" @set-script="setScript">
        </component>
      </TabPanel>
      <TabPanel :disabled="$route.params.facility_id == 0 || !info.isAdmin">
        <template #header>
          <img :src="require(`/public/images/24x24/45.png`)" width="20" />
          <span class="ml-1">Скрипт</span>
        </template>
        <DesignSetting :showError="form?.length && form.length === tabIndex"
          :scriptId="formScript ? formScript.script_id : null" :scrolling="form?.length === tabIndex"
          @add-script="addNewFS" />
      </TabPanel>
    </TabView>
    <Dialog v-model:visible="isDialogMessage" :style="{ width: '550px' }" :header="header" modal>
      {{ message }}
      <template #footer>
        <Button label="Ok" icon="pi pi-check" class="p-button-text" @click="isDialogMessage = false" />
      </template>
    </Dialog>
  </div>
</template>

<script setup>
import { ref, computed, watch, onMounted, onUnmounted, defineEmits } from 'vue';
import { useStore } from 'vuex';
import { useRouter, useRoute } from 'vue-router';
import axios from 'axios';
import EventBus from '@/core/EventBus';

// формы
import TTMBlockForm from "./forms/TTMBlockForm.vue";
import TTMGMSForm from "./forms/TTMGMSForm.vue";
import TTMGMSManualForm from "./forms/TTMGMSManualForm.vue";
import TTMLongStrokePumpDriverForm from "./forms/TTMLongStrokePumpDriverForm.vue";
import TTMVacuumForm from "./forms/TTMVacuumForm.vue";
import TTMWellForm from "./forms/TTMWellForm.vue";
import TTMWellClusterForm from "./forms/TTMWellClusterForm.vue";
import TTMMobileStationForm from "./forms/TTMMobileStationForm.vue";
import TTMFacilityPropertiesForm from "./forms/TTMFacilityPropertiesForm.vue";
import TTMLoadingStationForm from "./forms/TTMLoadingStationForm.vue";
import TTMEnergySubstationForm from "./forms/TTMEnergySubstationForm.vue";
import TTMMultiphasePumpForm from "./forms/TTMMultiphasePumpForm.vue";
import TTMInjectionWellForm from "./forms/TTMInjectionWellForm.vue";
import TTMFacilityCustomForm from "./forms/TTMFacilityCustomForm.vue";
import TTMDispenseForm from "./forms/TTMDispenseForm.vue";
import TTMGMPumpStationForm from "./forms/TTMGMPumpStationForm.vue";
import TTMAllFacilitiesForm from "./forms/TTMAllFacilitiesForm";
import TTMFacilitiesForm from "./forms/TTMFacilitiesForm";
import DesignSetting from "./DesignSetting";
import TTMEventForm from "./forms/TTMEventForm";
import TTMPropertyLogForm from "./forms/TTMPropertyLogForm";
import TTMPropertyLogChartForm from "./forms/TTMPropertyLogChartForm";

// композаблы
import { usePropertyUtils } from './forms/composables/usePropertyUtils.js';
import { useComponentUtils } from './forms/composables/useComponentUtils.js';
import { useShowMessage } from './forms/composables/useShowMessage.js';

const storeLocal = useStore();
const router = useRouter();
const route = useRoute();

const {
  propertyByNameFlangeNo: _propertyByNameFlangeNo,
  propertyByName: _propertyByName,
  propertyByURIFlangeNo: _propertyByURIFlangeNo,
  propertyBind: _propertyBind,
  valueWrite: _valueWrite,
  write: _write,
  getPropertyDB: _getPropertyDB,
  writeLoadedValue: _writeLoadedValue,
  propertyWrite: _propertyWrite,
  sendVariableForComponent: _sendVariableForComponent,
  valueWriteFromComponent: _valueWriteFromComponent,
  onGetVariable: _onGetVariable,
  execProc: _execProc,
  getType: _getType,
  preparePropertyEventData: _preparePropertyEventData,
  preparePropertyEvent: _preparePropertyEvent,
  propertyByEvent: _propertyByEvent,
} = usePropertyUtils();

const {
  componentByTypeId: _componentByTypeId,
  componentById: _componentById,
  componentByName: _componentByName,
  componentByTag: _componentByTag,
  createTable: _createTable,
  getChild: _getChild,
  prepareURI: _prepareURI,
  prepareURIData: _prepareURIData,
  getBit: _getBit,
  styleEventGroup: _styleEventGroup,
  toColor: _toColor,
  invertColor: _invertColor,
  varName: _varName,
  formatString: _formatString,
  //globalVariables: _globalVariables,
  //global: _global,
} = useComponentUtils();

const formComponents = {
  TTMBlockForm,
  TTMGMSForm,
  TTMGMSManualForm,
  TTMLongStrokePumpDriverForm,
  TTMVacuumForm,
  TTMWellForm,
  TTMWellClusterForm,
  TTMMobileStationForm,
  TTMFacilityPropertiesForm,
  TTMLoadingStationForm,
  TTMEnergySubstationForm,
  TTMMultiphasePumpForm,
  TTMInjectionWellForm,
  TTMFacilityCustomForm,
  TTMDispenseForm,
  TTMGMPumpStationForm,
  TTMAllFacilitiesForm,
  TTMFacilitiesForm,
  TTMEventForm,
  TTMPropertyLogForm,
  TTMPropertyLogChartForm
};

const {
  header,
  isDialogMessage,
  message,
  showMessage: _showMessage,
} = useShowMessage();

const formService = ref(null);
const formScriptService = ref(null);
const scriptService = ref(null);
const form = ref(null);
const formScript = ref(null);
const isLoading = ref({ form: false, formScript: false });
const isFSNotFound = ref(false);
const tabIndex = ref(null);
const firstLoop = ref(true);
let intervalLoadProp = null;
let intervalFirstLoadProp = null;
const propertyRunUpdate = ref(true);
const ready = ref({ property: false, script: false });
const defaultScript = ref(null);
const globalVariablesLocal = ref({});

const emit = defineEmits(['loading']);

const info = computed(() => storeLocal.getters.info);
const password = computed(() => storeLocal.getters.password);

const loading = computed(() => {
  // computed не вычислится так как не где не вызывается loading
  const load = isLoading.value.formScript || isLoading.value.form || false;
  emit('loading', load)
  return load;
});

function getFacilityNameBracket() {
  const facilityName = getFacilityName();
  return facilityName ? `(${facilityName})` : '';
}

function getFacilityName() {
  return getFacility(route.params.facility_id);
}

function getFacility(facilityId) {
  if (facilityId == 0 || !storeLocal.getters.facility.length) return '';
  for (const element of storeLocal.getters.facility) {
    if (facilityId == element.facility_id) return element.facility_name;
  }
  return '';
}

function onStartExec(source) {
  const exclClass = ["TTMPropertyLogChartForm", "TTMFacilityPropertiesForm"];
  if (
    ready.value.script ||
    ready.value.property ||
    exclClass.includes(route.query.form_class)
  ) {
    clearInterval(intervalLoadProp);
    clearInterval(intervalFirstLoadProp);
    intervalFirstLoadProp = setTimeout(
      () => getValue("onStartExec", exclClass.includes(route.query.form_class)),
      200
    );
    intervalLoadProp = setInterval(() => {
      if (propertyRunUpdate.value)
        getValue("interval", exclClass.includes(route.query.form_class));
    }, storeLocal.getters.propertyUpdate * 1000);
  }
  ready.value[source] = true;
}

function setScript(script) {
  defaultScript.value = script;
}

function getValue(source, stopScript = false) {
  const login = info.value.login;
  const pwd = password.value;

  const api = `${storeLocal.getters.server(
    "TM_MIDDLE"
  )}kron.tm3.service-web-1.0/webresources/restservice/facility/json/utf-8/`;
  const headers = {
    Authorization: "Basic " + btoa(login + ":" + pwd),
    "Content-Type": "application/zip",
  };

  if (route.params.facility_id && route.params.facility_id !== "0") {
    axios
      .get(api + route.params.facility_id, { headers })
      .then((response) => {
        if (!response.data) return;
        const properties = [
          ...response.data.properties,
          ...response.data.liqProperties,
        ];
        const systemProp = _prepareURIData(properties, "sysName", "flangeNo", "");
        const dataProp = _prepareURIData(properties, "typeName", "flangeNo");

        const facility = {
          name: response.data?.name,
          typeName: response.data?.typeName,
          id: response.data?.id,
        };

        const flanges = response.data.flanges.filter((item) => item.actual);
        const childFlangeData = response.data.childFlangeData ?? [];
        const parentFlangeData = response.data.parentFlangeData ?? [];

        // биндинги для eval
        const propertyByNameFlangeNo = _propertyByNameFlangeNo.bind(null, systemProp);
        const propertyByEvent = _propertyByEvent.bind(null, systemProp);

        const propertyByName = _propertyByName.bind(null, [...properties]);
        const propertyByURIFlangeNo = _propertyByURIFlangeNo.bind(null, dataProp);
        const componentByTypeId = _componentByTypeId.bind(null, storeLocal.getters.designWeb);
        const componentByTag = _componentByTag.bind(null, storeLocal.getters.designWeb);
        const componentById = _componentById.bind(null, storeLocal.getters.designWeb);
        const componentByName = _componentByName.bind(null, storeLocal.getters.designWeb);
        const createTable = _createTable.bind(null, storeLocal.getters.components);
        const getChild = _getChild.bind(null, facility.id);
        const showMessage = _showMessage;
        const propertyWrite = _propertyWrite.bind(null, systemProp, [...properties]);
        const valueWrite = _valueWrite.bind(null, systemProp);
        const sendVariableForComponent = _sendVariableForComponent;
        const execProc = _execProc;
        const formatString =_formatString;
        const valueWriteFromComponent = _valueWriteFromComponent.bind(
          null,
          systemProp,
          storeLocal.getters.designWeb
        );
        //console.log(storeLocal.getters.designWeb, systemProp);

        const propertyBind = _propertyBind.bind(
          null,
          storeLocal.getters.designWeb,
          systemProp
        );
        const global = _global;
        const script = storeLocal.getters.script ?? defaultScript.value;
        const globalVariables = globalVariablesLocal.value;
        const typeFormat = storeLocal.getters.typeFormat;
        const lastEvent = _preparePropertyEventData(response.data.activeEvents);
        const activeEvents = response.data.activeEvents;
        const styleEventGroup = _styleEventGroup;
        const getBit = _getBit;
        const writeLoadedValue = _writeLoadedValue;
        const onGetVariable = _onGetVariable;
        const store = storeLocal;//
        const getPropertyDB = _getPropertyDB;
        const varName = _varName;
        const numberToColor = _toColor;
        const emit = EventBus.emit;
        const addScriptLog = (m) => storeLocal.dispatch("addScriptLog", m);
        const isEmpty = (v) => v === "" || v === null || v === undefined;

        const property = properties.filter((item) => item.isVisibleForm);

        storeLocal.dispatch("setEvents", activeEvents);
        storeLocal.dispatch("setActiveFlanges", flanges);
        storeLocal.dispatch("setPropertyAll", properties);
        storeLocal.dispatch("setProperty", property);
        storeLocal.dispatch("setDataProperty", dataProp);
        storeLocal.dispatch("setSysProperty", systemProp);
        storeLocal.dispatch("setEvent", lastEvent);
        storeLocal.dispatch("setFacilityCurrent", facility);

        if (
          script?.facility_changed_script &&
          storeLocal.getters.scriptChange &&
          firstLoop.value &&
          !stopScript
        ) {
          try {
            // eslint-disable-next-line no-eval
            eval(script.facility_changed_script);
          } catch (error) {
            storeLocal.commit("SET_ERROR", {
              er: `${error}. Ошибка при заполнении формы объекта. Проверьте корректность скрипта.`,
              source: ["FacilityForm", "Cкрипт объекта запущен"],
            });
            storeLocal.dispatch("addScriptLog", {
              message: `${error}. Скрипт заполнения формы не выполнился.`,
              facilityId: facility.id,
            });
          }
        }
        if (script?.facility_process_script && storeLocal.getters.scriptProcess && !stopScript) {
          try {
            // eslint-disable-next-line no-eval
            eval(script.facility_process_script);
          } catch (error) {
            storeLocal.dispatch("setScriptProcess", false);
            storeLocal.commit("SET_ERROR", {
              er: `${error}. Ошибка при обработке объекта. Проверьте корректность скрипта обработки.`,
              source: ["FacilityForm", "facility_process_scripts"],
            });
            storeLocal.dispatch("addScriptLog", {
              message: `${error} (выполенние скрипта объекта остановлено)`,
              facilityId: facility.id,
            });
          }
        }
        if (firstLoop.value) {
          firstLoop.value = false;
          EventBus.emit("on-first-property-update", facility);
        }
      })
      .catch((er) => {
        storeLocal.dispatch("setPropertyAll", []);
        storeLocal.dispatch("setProperty", []);
        storeLocal.dispatch("setEvents", []);
        storeLocal.dispatch("setActiveFlanges", []);
        storeLocal.dispatch("setDataProperty", {});
        storeLocal.dispatch("setFacilityCurrent", {
          id: route.params.facility_id,
        });
        storeLocal.dispatch("addScriptLog", {
          message: `Ошибка получения свойств объекта: ${er.response || er}`,
          facilityId: route.params.facility_id,
        });
      });
  }
}

function onTabChange(index) {
  if (tabIndex.value === form.value.length) {
    EventBus.emit("on-check-save-script");
  }
  tabIndex.value = index;
  ready.value.property = false;
  ready.value.script = false;
  replaceFormClass(index);
  if (index === 0) onLoadFormScript();
}

function replaceFormClass(index) {
  let formClass = {};
  if (index > form.value.length - 1) formClass = { form_class: "TTMScript" };
  else formClass = { form_class: form.value[index].form_class };
  router.replace({ query: formClass });
}

function onLoadForm() {
  isLoading.value.form = true;
  if (!formService.value) {
    formService.value = storeLocal.getters.nameToService(
      "BaseService",
      info.value.login,
      password.value,
      "form",
      "data"
    );
  }
  const params = { node_type_id: route.params.node_type_id };
  formService.value
    .getData(params)
    .then((data) => {
      form.value = data;
      onLoadFormScript();
      if (route.query.form_class) {
        let index = form.value.findIndex(
          (item) => item.form_class === route.query.form_class
        );
        if (
          index === -1 &&
          route.query.form_class === "TTMScript" &&
          info.value.isAdmin
        ) {
          index = form.value.length;
        }
        if (index === -1) resetTabIndex();
        else tabIndex.value = index;
      } else resetTabIndex();
    })
    .catch((er) => storeLocal.commit("SET_ERROR", er))
    .finally(() => (isLoading.value.form = false));
}

function resetTabIndex() {
  tabIndex.value = 0;
  replaceFormClass(0);
}

function onLoadFormScript() {
  isLoading.value.formScript = true;
  firstLoop.value = true;
  if (!formScriptService.value) {
    formScriptService.value = storeLocal.getters.nameToService(
      "BaseService",
      info.value.login,
      password.value,
      "form_script",
      "row"
    );
  }
  const params = {
    form_id: form.value[0].form_id,
    facility_id: route.params.facility_id,
    facility_type_id: route.params.facility_type_id,
  };

  formScriptService.value
    .getData(params)
    .then((data) => {
      if (!data || data.length === 0) isFSNotFound.value = true;
      else {
        isFSNotFound.value = false;
        formScript.value = { ...data[0] };
      }
      EventBus.emit("on-load-script-data");
    })
    .catch((er) => storeLocal.commit("SET_ERROR", er))
    .finally(() => (isLoading.value.formScript = false));
}

function clearForm() {
  formScript.value = null;
  firstLoop.value = true;
  storeLocal.dispatch("setScriptProcess", true);
  storeLocal.dispatch("setScriptChange", true);
}

function addNewFS() {
  if (!scriptService.value) {
    scriptService.value = storeLocal.getters.nameToService(
      "BaseService",
      info.value.login,
      password.value,
      "script",
      "row"
    );
  }

  scriptService.value
    .insertData({
      script_id: null,
      script_name: `${form.value[0].form_name}: ${getFacilityName()}`,
      construction_script: defaultScript.value?.construction_script
        ? defaultScript.value.construction_script
        : null,
      facility_changed_script: defaultScript.value?.facility_changed_script
        ? defaultScript.value.facility_changed_script
        : null,
      facility_process_script: defaultScript.value?.facility_process_script
        ? defaultScript.value.facility_process_script
        : null,
      design_form: null,
      design_web: defaultScript.value?.design
        ? defaultScript.value.design
        : null,
    })
    .then((data) => {
      isLoading.value.formScript = true;
      if (!formScriptService.value) {
        formScriptService.value = storeLocal.getters.nameToService(
          "BaseService",
          info.value.login,
          password.value,
          "form_script",
          "row"
        );
      }
      formScript.value = null;

      formScriptService.value
        .insertData({
          form_script_id: null,
          form_id: form.value[0].form_id,
          facility_type_id: null,
          facility_id: route.params.facility_id,
          script_id: data[0].script_id,
        })
        .then((dataFS) => {
          isFSNotFound.value = false;
          formScript.value = {
            form_script_id: dataFS[0].form_script_id,
            form_id: form.value[0].form_id,
            facility_type_id: null,
            facility_id: route.params.facility_id,
            script_id: data[0].script_id,
          };
        })
        .catch((er) =>
          storeLocal.commit("SET_ERROR", {
            er,
            source: ["FacilityForm", "formScriptService"],
          })
        )
        .finally(() => (isLoading.value.formScript = false));
    })
    .catch((er) =>
      storeLocal.commit("SET_ERROR", {
        er,
        source: ["FacilityForm", "scriptService"],
      })
    );
}

function _global(item, name) {
  globalVariablesLocal.value[name] = item;
}

onMounted(() => {
  EventBus.on("on-start-execution", onStartExec);
  EventBus.on("on-stop-update-property", () => {
    clearInterval(intervalLoadProp);
    clearInterval(intervalFirstLoadProp);
  });
  EventBus.on("on-load-form-script", onLoadFormScript);
  EventBus.on("on-update-property", (flag) => {
    propertyRunUpdate.value = flag;
  });
});

onUnmounted(() => {
  clearInterval(intervalLoadProp);
  clearInterval(intervalFirstLoadProp);
  EventBus.off("on-update-property");
  EventBus.off("on-load-form-script");
  EventBus.off("on-stop-update_property");
  EventBus.off("on-start-execution");
});

watch(
  () => route.params,
  (value, oldValue) => {
    if (
      (route.name === "form" || route.name === "facility-map-child") &&
      (!oldValue || value.facility_id !== oldValue.facility_id)
    ) {
      ready.value.property = false;
      ready.value.script = false;
      clearForm();
      onLoadForm();
    }
  },
  { immediate: true }
);

watch(tabIndex, (val) => {
  if (val !== 0) EventBus.emit("on-destroy-moveable");
});


</script>

<style lang="scss" scoped>
.form-tab {
  ::v-deep(.p-tabview .p-tabview-nav li .p-tabview-nav-link) {
    font-weight: normal;
    padding: 0.26rem;
  }

  ::v-deep(.p-tabview-panels) {
    padding: 0.1rem;
  }
}

.my-class.other-class {
  padding: 0.4rem;
}

@media screen and (max-width: 960px) {
  .form-tab {
    ::v-deep(.p-tabview .p-tabview-nav li .p-tabview-nav-link) {
      padding: 0.2rem;
    }
  }

  .my-class.other-class {
    padding: 0.2rem;
  }
}

@media screen and (max-width: 740px) {
  .form-tab-text {
    display: none;
  }
}
</style>